import { ContactPageContentData } from "../../../../models/interface";

export const contactInputFields = (prevState?: ContactPageContentData) => {
  return {
    title: prevState?.title ?? "",
    informatoryText: prevState?.informatoryText ?? [],
    altText: prevState?.altText ?? "",
  } as ContactPageContentData;
};
